import { render } from "./InventarioViews.vue?vue&type=template&id=6c6ffd5c&scoped=true"
import script from "./InventarioViews.vue?vue&type=script&lang=js"
export * from "./InventarioViews.vue?vue&type=script&lang=js"

import "./InventarioViews.vue?vue&type=style&index=0&id=6c6ffd5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6ffd5c"]])

export default __exports__